import { getAll } from '../../../../../utils/api';
import { RolDto } from '../../../dtos/rol.dto';

export const GetRolesService = async () => {
  const response = await getAll<RolDto[]>(`users/access/roles`);
  return response;
};